import React from 'react';
import { cj } from 'src/utils/classNames';
import Link from 'src/components/primitives/Link/Link';
import { DesktopNavDropdownContentProps } from 'src/components/Navigation/DesktopNav/DesktopNavDropdown/types';
import DesktopNavDropdownContentButton from 'src/components/Navigation/DesktopNav/DesktopNavDropdown/DesktopNavDropdownContentButton';
import { Z_INDEX } from 'src/constants/zIndex';
import {
	MORE_CATEGORY_GENERAL_LINKS,
	MORE_CATEGORY_SOCIAL_LINKS,
} from 'src/components/Navigation/DesktopNav/DesktopNavDropdown/consts';

const DesktopNavDropdownContent = ({
	navOption,
	currentNavSelection,
	className,
	onClick,
	...rest
}: DesktopNavDropdownContentProps) => {
	const isMoreCategory = navOption?.categoryName === 'more';

	return (
		<div
			className={cj(
				'overflow-hidden rounded-sm border border-stroke-divider bg-menu-bg shadow-md',
				isMoreCategory ? 'w-[640px]' : 'w-[320px]',
				Z_INDEX.dropdown,
				className
			)}
			{...rest}
		>
			<div className={isMoreCategory ? 'grid grid-cols-2' : 'flex flex-col'}>
				{navOption.options.map((categoryOption) => (
					<DesktopNavDropdownContentButton
						key={categoryOption.name}
						categoryOption={categoryOption}
						onClick={onClick}
						currentNavSelection={currentNavSelection}
					/>
				))}
			</div>

			{/* Footer with links for the "more" dropdown. */}
			{isMoreCategory && (
				<div
					className={cj(
						'flex items-center justify-between px-lg py-md typo-t4 text-text-secondary',
						'border-t border-stroke-divider'
					)}
				>
					<div className="flex items-center gap-x-2xl">
						{MORE_CATEGORY_GENERAL_LINKS.map((link) => (
							<Link
								key={link.href}
								variant="secondary"
								href={link.href}
								openInNewTab
							>
								{link.label}
							</Link>
						))}
					</div>
					<div className="flex items-center gap-x-lg">
						{MORE_CATEGORY_SOCIAL_LINKS.map((link) => (
							<Link
								key={link.href}
								variant="secondary"
								// `typo-b2` defines the size of the icon.
								className="flex typo-b2"
								href={link.href}
								rightIcon={link.icon}
							/>
						))}
					</div>
				</div>
			)}
		</div>
	);
};

export default React.memo(DesktopNavDropdownContent);
